<template>
  <HvhHoverElement class="position-relative h-100 pr-5" :class="{ 'inline-block': !isEditing }" v-model="isHovering">
    <div>
      <HvhEditable component="div" class="name" v-model="editData.name" :isEditing="isEditing" placeholder="Name" @keydown.enter.prevent="saveTitleEdit">
        <router-link class="name" :to="{ name: 'cohort', params: { id: value.id } }">{{ value.name }}</router-link>
      </HvhEditable>
    </div>
    <div>
      <HvhEditable component="div" class="description" v-model="editData.description" :isEditing="isEditing" placeholder="Description" @keydown.enter.prevent="saveTitleEdit" />
    </div>
    <div>
      <HvhEditable component="p" class="my-1" :value="cohortTags" @input="cohortTagsChanged" :isEditing="isEditing" placeholder="Tags" @keydown.enter.prevent="saveTitleEdit">
        <div class="hvh-flex wrap mt-2" v-if="value.tags.any()">
          <DPDPill class="pill" :label="item" v-for="(item, ind) in value.tags" :key="ind" />
        </div>
      </HvhEditable>
    </div>

    <CohortHeaderEditButtons v-model="isEditing" :isHovering="isHovering" @input="isHovering = false" @save="saveTitleEdit" v-if="value.isEditableByUser && value.creationStatus === 'Done'" />
    <loader v-if="isLoading" />
  </HvhHoverElement>
</template>

<script>
import axios from '../../../../axios';
import { customNumberFormat, errorDebug } from '../../../../libraries/common';
import HvhHoverElement from '../../../common/hover/HvhHoverElement.vue';
import HvhEditable from '../../../common/editable/HvhEditable.vue';
import CohortHeaderEditButtons from './CohortHeaderEditButtons.vue';
export default {
  export: false,
  components: { HvhHoverElement, HvhEditable, CohortHeaderEditButtons },
  props: ['value'],
  data() {
    return {
      editData: this.createData(this.value),
      isEditing: false,
      isLoading: false,
      isHovering: false,
    };
  },
  computed: {
    cohortTags() {
      return this.editData.tags
        .map(f => f.startsWith("#") ? f : "#" + f)
        .join(' ');
    },
  },
  methods: {
    createData(value) {
      const { name, description, tags } = value;
      return { name, description, tags };
    },
    saveTitleEdit() {
      this.isLoading = true;
      axios
        .patch(`/Analytics/Cohort/${this.value.id}/Save`, this.editData)
        .then(() => {
          this.$emit('input', { ...this.value, ...this.editData });
          this.isEditing = false;
        })
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
    cohortTagsChanged(event) {
      var tags = (event || '').split(' ')
        .map(f => (f.startsWith("#") ? f : "#" + f).trim())
        .filter(f => f);
      this.editData = {
        ...this.editData,
        tags,
      }
    },
    customNumberFormat,
  },
  watch: {
    value() {
      this.editData = this.createData(this.value);
    },
    isEditing() {
      this.editData = this.createData(this.value);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCohortHeaderEdit'] = this;
  },
};
</script>

<style lang="scss" scoped>
.name {
  color: #3d3f41;
  font-size: 18px;
  font-weight: 500;
}

.description {
  color: #181815;
}

.button-box {
  position: absolute;
  top: 0;
  right: 0;
}
</style>